import { NextPage } from "next";

import InsertOffer from "scenes/InsertOffer";

const Index: NextPage = () => <InsertOffer />;

export default Index;
